export function sortMethod(a: any, b: any, valCls?: string, customMethod?: (a: any, b: any) => number) {
    // console.log(a, b, desc);
    const vA = getValue(a, valCls);
    const vB = getValue(b, valCls);
    // console.log(vA, vB);
    if (customMethod) {
        return customMethod(vA, vB);
    }
    return compare(vA, vB);
}

function getValue(c: any, valCls?: string): any {
    let val;
    if (c && typeof c === 'object' && c.props) {
        if (c.props.className === (typeof valCls === 'string' ? valCls : 'value_sort') &&
            (typeof c.props.children === 'string' || typeof c.props.children === 'number')) {
            val = c.props.children;
        } else if (c.props.children) {
            if (Array.isArray(c.props.children)) {
                c.props.children.some((r: any) => val = getValue(r));
            } else {
                val = getValue(c.props.children);
            }
        }
    }
    return val;
}

function compare(a: string, b: string) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
        return 1;
    }
    if (a < b) {
        return -1;
    }
    return 0;
}

export function compareSelect(a: any, b: any) {
    // force null and undefined to the bottom
    a = a === null || a === undefined || a === 0 ? '' : a;
    b = b === null || b === undefined || b === 0 ? '' : b;
    // force any number values to string
    a = typeof a === 'number' ? a.toString() : a;
    b = typeof b === 'number' ? b.toString() : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
        return 1;
    }
    if (a < b) {
        return -1;
    }
    return 0;
}
